import React from 'react';

const FeatureNav = () => {
    const navItems = [
        {
            id: 1,
            text: "Add Styling",
            icon: "/features/styling.png",
        },
        {
            id: 2,
            text: "Sync Data",
            icon: "/features/sync.svg",
        },
        {
            id: 3,
            text: "Integrations",
            icon: "/features/integrations.svg",
        },
        {
            id: 4,
            text: "Google add-on",
            icon: "/features/google.svg",
        },
        {
            id: 5,
            text: "Report",
            icon: "/features/report.png",
        },
        {
            id: 6,
            text: "Analytics",
            icon: "/features/analytics.png",
        }
    ];

    return (
        <div className="flex justify-center items-center w-full px-4 py-12">
            <div className="flex flex-wrap gap-5 items-center">
                {navItems.map((item) => (
                    <button
                        key={item.id}
                        className={`
              flex items-center gap-2 px-4 py-2 rounded-full
              border border-gray-200 hover:border-gray-300
              transition-colors duration-200
              bg-white
            `}
                    >
                        <img
                            src={item.icon}
                            alt={`${item.text} icon`}
                            className="object-contain"
                        />
                        <span className="text-sm text-[#697586] font-medium">
                            {item.text}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default FeatureNav;